import React, { useContext } from "react";
import { TargetsContext } from "../../contexts";

/** Init the data for the chart.
 *
 */
export const Location = (props) => {
  const targets = useContext(TargetsContext);
  const { index } = props;
  const { area, country, flag } = targets[index];

  return (
    <>
      <div className='d-flex align-items-center mb-2'>
        <div className='border'>
          <img width='75px' src={`${flag}`}></img>
        </div>
        <div className='d-inline-flex align-items-baseline'>
          <div className='fs-3 fw-bold text-dark ms-3'>{area}</div>
          <div className='ms-3 fs-5 text-secondary'>{country}</div>
        </div>
      </div>
    </>
  );
};
